<template>
	<div class="item-content">
		<div
			ref="textWrap"
			:class="['text-wrap', textWrapClosed ? '' : 'opened']">
			<div
				ref="text"
				:class="['text', textClosed ? 'f-toe3' : '']">
				{{item.content}}
			</div>
		</div>
		<div
			:class="['toggle-wrap', showToggle ? '' : 'f-dn', textClosed ? 'closed' : 'opened']">
			<a class="toggle-btn" @click="toggleText">
				<span>{{textClosed ? '展开' : '收起'}}</span>
				<span class="icon-arrow"></span>
			</a>
		</div>
	</div>
</template>

<script>
import imgMixin from 'mixins/image'
export default {
	mixins: [imgMixin],
	props: ['item', 'hide'],
	data() {
		return {
			textWrapClosed: true,
			textClosed: false,
			showToggle: false
		}
	},
	watch: {
		hide(newVal, oldVal) {
			this.calcHeight();
		}
	},
	mounted() {
		this.calcHeight();
	},
	methods: {
		calcHeight() {
			this.$nextTick(function() {
				const textWrap = this.$refs.textWrap;
				const text = this.$refs.text;
				const outerH = textWrap.offsetHeight;
				const innerH = text.offsetHeight;
				if(outerH < innerH) {
					this.textClosed = true;
					this.showToggle = true;
				}
			});
		},
		toggleText() {
			this.textWrapClosed = !this.textWrapClosed;
			this.textClosed = !this.textClosed;
		}
	}
}
</script>


// WEBPACK FOOTER //
// item-content.vue?b94e3c48